import { getUdfsData } from '../../data/apis/api';
import { useRestQuery } from '../../data/util';
import { QueryKey } from './config';

export const useUDFsData = (transpilerId: string, disabled?: boolean) => {
  const data = useRestQuery([QueryKey, 'getAllUdfs', transpilerId], () => getUdfsData(transpilerId), {
    retry: false,
    refetchOnMount: true,
    enabled: !!transpilerId && !disabled,
    sentryTag: 'transpiler.getAllUdsData'
  });

  return data;
};
